import React, { createContext, useCallback, useState, useContext } from 'react';

import { ConnectionContextData } from './interface';

const NotificationsContext = createContext<ConnectionContextData>(
  {} as ConnectionContextData,
);

export const ConnectionProvider: React.FC = ({ children }) => {
  const [_status, _setStatus] = useState(true);

  const setStatus = useCallback(pTotal => {
    _setStatus(pTotal);
  }, []);

  return (
    <NotificationsContext.Provider value={{ status: _status, setStatus }}>
      <>{children}</>
    </NotificationsContext.Provider>
  );
};

export function useConnection(): ConnectionContextData {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('hook usada fora de contexto de connection!');
  }
  return context;
}
